import { render, staticRenderFns } from "./NewCriterio.vue?vue&type=template&id=11d25c88&scoped=true"
import script from "./NewCriterio.vue?vue&type=script&lang=js"
export * from "./NewCriterio.vue?vue&type=script&lang=js"
import style0 from "./NewCriterio.vue?vue&type=style&index=0&id=11d25c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11d25c88",
  null
  
)

export default component.exports